export default ":host {\n  background-color: var(--rp-color-gray50);\n  display: flex;\n  justify-content: center;\n}";